import { call, put, select, takeEvery } from 'redux-saga/effects'
import { reset } from 'redux-form'
import { getAuth } from '../../selectors/access/auth'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getVOCompanies from '../../services/dossier/get/getVOCompanies'

export function * fetchVoCompaniesCombo ({ organizedUnitId }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const combo = yield call(getVOCompanies, organizedUnitId, auth.token)
    yield put(fetchCombosSuccess({ voCompaniesCombo: combo }))
  } catch (error) {
    const sessionHandler = function * () {
      yield put(reset('selectVoCompany'))
    }
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchVoCompaniesCombo () {
  yield takeEvery(combosActionTypes.FETCH_VO_COMPANIES_COMBO, fetchVoCompaniesCombo)
}
